// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__MwWvM","logoWrapper":"Header_logoWrapper__fFX5E"};